import actionTypes from './actionTypes';

// eslint-disable-next-line import/prefer-default-export
export const saveGridListSortSelection = (currentSelection) => ({
  type: actionTypes.CLIENTS_SET_SORTBY_AND_VIEWTYPE,
  payload: currentSelection,
});
